import {useCallback, useMemo, useReducer} from "react";


const useDataTableFilters = (props) => {
    const {initialFiltersValue, onFilterChanged} = props ?? {};

    const [filters, updateFilters] = useReducer(
        (oldState, partialState) => ({...oldState, ...partialState}),
        initialFiltersValue ?? {}
    );

    const filterFetchOptions = useMemo(() => ({
        ...Object.entries(filters).reduce((acc, [key, value]) => {
            if (value != null) {
                acc[key] = value
            }
            return acc
        }, {}),
    }), [filters]);

    const handleChangeGlobalFilter = (value) => {
        if (!!value) {
            updateFilters({search: value})
        }
        else {
            updateFilters({search: null})
        }
        if (onFilterChanged){
            onFilterChanged()
        }
    }

    const handleChangeFilter = useCallback((filter) => {
        updateFilters(filter)
        if (onFilterChanged){
            onFilterChanged()
        }
    }, [updateFilters, onFilterChanged])

    return {
        filters,
        filterFetchOptions,
        onGlobalFilterChange: handleChangeGlobalFilter,
        onFilterChange: handleChangeFilter
    }

}


export default useDataTableFilters;